'use client';

import { LazyMotion, MotionConfig } from 'framer-motion';
import { ReactNode } from 'react';

// The animation features are split into their own chunk and loaded after
// hydration, so `m` components render immediately without the full bundle
const loadFeatures = () =>
  import('./motion-features').then(response => response.default);

export const MotionProvider = ({ children }: { children: ReactNode }) => {
  return (
    // strict throws when a full `motion` component is rendered, which would
    // pull framer-motion back into the initial bundle
    <LazyMotion features={loadFeatures} strict>
      <MotionConfig reducedMotion="user">{children}</MotionConfig>
    </LazyMotion>
  );
};
